import { Routes } from '@angular/router';
import { AppAuthGuard } from '../modules/shared/services/auth-guard/auth-guard.service';
import { ErrorComponent } from '../components/error/error.component';
import { ShowVersionComponent } from '../components/show-version/show-version.component';


export const SECURE_ROUTES: Routes =[
  {
    path: '',
    data: {title: 'Dashboard'},
    pathMatch:'full',
    redirectTo: 'dashboard'

  },
  {
    path: 'errorpage',
    component: ErrorComponent
  },
  {
    path: 'dashboard',
    canActivate: [AppAuthGuard],
    data: {title: 'Dashboard',roles: ['ROLE_BK', 'ROLE_EMP']},
    loadChildren: () => import('../modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'travel-form/:formId',
    canActivate: [AppAuthGuard],
    data: {title: 'TravelExpenseForm',roles: ['ROLE_BK', 'ROLE_EMP']},
    loadChildren: () => import('../modules/expense-form/expense-form.module').then((m) => m.ExpenseFormModule),
  },
  {
    path: 'app-version',
    component: ShowVersionComponent
  }
]
